export default __webpack_public_path__ + "static/media/card-1.66ab882b.png";